import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumb from "../../../components/layout/Breadcrumb";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { fetchPolicies } from "../../../redux/slice/policiesSlice";
import { useNavigate } from "react-router-dom";
import PolicyPreviewModal from "./PolicyPreviewModal";
import { toast, ToastContainer } from "react-toastify";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import { useHasPermission } from "../../../hooks/useHasPermission";

export default function PolicyList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [displayedPolicies, setDisplayedPolicies] = useState([]);
  const user = useSelector((state) => state.getUserId?.User);
  const userLoading = useSelector((state) => state.getUserId?.loading);
   const { list = [], loading, error } = useSelector(
    (state) => state.policies
  );
  const canViewPolicy = useHasPermission("Policies-view");
  const canEditPolicy = useHasPermission("Policies-manage");

  useEffect(() => {
    if (!canViewPolicy) return;
    dispatch(fetchPolicies());
  }, [dispatch, canViewPolicy]);

  useEffect(() => {
    setDisplayedPolicies(list);
  }, [list]);


  const handleView = (policy) => {
    setSelectedPolicy(policy);
    setShowViewModal(true);
  };

  const role = user?.roleName || 'Admin';
  const stripHtml = (html = "") => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  if (userLoading) { return <p>Loading user...</p>; }
  if (!role) { return <p>Loading permissions...</p>; }
  if (!canViewPolicy) { return (<p className="perm-msg">You don’t have permission to view policies!</p>); }

  const handleViewEdit = (id) => {
    if (!canEditPolicy) {
      toast.error("You don't have permission to edit policies", { className: "toast-error-custom", autoClose: 5000, });
      return;
    }
    navigate(`/admin/policies/detail?id=${id}`);
  };

  const handleCreate = () => {
    if (!canEditPolicy) {
      toast.error("You don't have permission to create policies", { className: "toast-error-custom", autoClose: 5000, });
      return;
    }
    navigate("/admin/policies/create");
  };
  return (
    <div className="container-fluid" style={{ marginBottom: "30px" }}>
      <Breadcrumb />
      <div className=" d-flex justify-content-between align-items-center" style={{ flexDirection: "row-reverse", marginBottom: "18px" }}>
        <div className="icons-list">
          <h5 className="mb-3 mt-1">Company Policies</h5>
          {canEditPolicy && (
            <div> <button type="button" className="primary-btn ml-4" onClick={handleCreate}>
              <i className="fe fe-plus"></i>+ Create Policy
            </button>
            </div>
          )}
        </div>
      </div>
      <div className="section-body">
        <div className="container-fluid">
          <div className="tab-content">
            <div className="tab-pane fade active show" id="Employee-list" role="tabpanel" >
              <div className="card-policy">
                <div className="card-body pt-0 pb-0">
                  {loading && <p className="loading-msg">Loading policies...</p>}
                  <div className="policies-container table-responsive m-0" style={{ width: "100%" ,overflow: "auto" }}>
                    <table id="candidate-table" className="table table-bordered table-hover table-vcenter text-nowrap mb-0" >
                      <thead>
                        <tr>
                          <th style={{ width: "45px", textAlign: "center" }}>ID</th>
                          <th>Title</th>
                          <th>Description</th>
                          <th>Author</th>
                          <th>Updated By</th>
                          <th>Created At</th>
                          <th>Status</th>
                          <th
                            ref={(el) => {
                              if (el) {
                                el.style.setProperty("padding", "0", "important");
                                el.style.setProperty("width", "55px");
                                el.style.setProperty("text-align", "center");
                              }
                            }}
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      {error && (<tbody>
                        <tr>
                          <td colSpan="8" className="text-center">
                            <p className="server-error-msg">-- Unable connect to server --</p>
                          </td>
                        </tr>
                      </tbody>
                      )}

                      {!error && !loading && displayedPolicies.length === 0 && (
                        <tbody>
                          <tr>
                            <td colSpan="8" className="text-center">
                              <p className="server-error-msg">-- No policies found --</p>
                            </td>
                          </tr>
                        </tbody>
                      )}
                      {!loading && displayedPolicies.length > 0 && (
                        <tbody>
                          {displayedPolicies.map((policy) => (
                            <tr key={policy.id}>
                              <td>{policy.id}</td>
                              <td style={{ textAlign: "left" }}>{policy.title || "-"}</td>
                              <td className="text-left" style={{ textAlign: "left" }}>
                                {stripHtml(policy.contentHtml).slice(0, 120)}
                                {stripHtml(policy.contentHtml).length > 120 ? "..." : ""}
                              </td>
                              <td><OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id={`createdBy-tooltip-${policy.id}`}>
                                      {policy.createdBy || "-"}
                                    </Tooltip>
                                  }
                                >
                                  <span style={{ cursor: 'pointer' }}>
                                    {policy.createdBy || "-"}
                                  </span>
                                </OverlayTrigger></td>
                              <td><OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id={`updatedBy-tooltip-${policy.id}`}>
                                      {policy.updatedBy || "-"}
                                    </Tooltip>
                                  }
                                >
                                  <span style={{ cursor: 'pointer' }}>
                                    {policy.updatedBy || "-"}
                                  </span>
                                </OverlayTrigger></td>
                              <td>
                                {policy.createdAt ? new Date(policy.createdAt).toLocaleString() : "-"}
                              </td>
                              <td>
                                <span className={`badge ${policy.status ? "bg-success" : "bg-secondary"}`}>
                                  {policy.status ? "Active" : "Inactive"}
                                </span>
                              </td>
                              <td className="action-column">
                                <PopupState variant="popover" popupId={`policy-action-${policy.id}`}>
                                  {(popupState) => (
                                    <>
                                      <button
                                        type="button"
                                        className="btn btn-icon btn-sm icons"
                                        {...bindTrigger(popupState)}
                                        title="Actions"
                                      >
                                        <img
                                          src={require("assets/img/more.png")}
                                          alt="actions"
                                          className="action-icon"
                                        />
                                      </button>

                                      <Menu {...bindMenu(popupState)}>
                                        <MenuItem
                                          onClick={() => {
                                            popupState.close();
                                            handleView(policy);
                                          }}
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-icon btn-sm icons me-2"
                                            title={
                                              canViewPolicy
                                                ? "view"
                                                : "No permission"
                                            }
                                            disabled={!canViewPolicy}
                                          >
                                            <img
                                              src={require("assets/img/view-icon.png")}
                                              alt="view"
                                              className="action-icon"
                                              style={{
                                                width: 15,
                                                opacity: canViewPolicy ? 1 : 0.5,
                                              }}
                                            />
                                          </button>
                                          <span>View</span>
                                        </MenuItem>

                                        {/* <MenuItem disabled>
                                          <i className="fe fe-file-text me-2"></i>
                                          View PDF
                                        </MenuItem> */}

                                        {/* EDIT */}
                                        {canEditPolicy && (
                                          <MenuItem
                                            onClick={() => {
                                              popupState.close();
                                              handleViewEdit(policy.id);
                                            }}
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-icon btn-sm icons me-2"
                                              disabled={!canEditPolicy}
                                              title={
                                                canEditPolicy
                                                  ? "edit"
                                                  : "No permission"
                                              }
                                            >
                                              <img
                                                src={require("assets/img/edit-icon.png")}
                                                alt="Edit"
                                                className="action-icon me-2"
                                                style={{
                                                width: 15,
                                                opacity: canEditPolicy ? 1 : 0.5,
                                              }}
                                              />
                                            </button>
                                            <span>Edit</span>
                                          </MenuItem>
                                        )}
                                      </Menu>
                                    </>
                                  )}
                                </PopupState>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PolicyPreviewModal
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        policy={selectedPolicy}
        canEdit={canEditPolicy}
        onEdit={(id) => {
          setShowViewModal(false);
          navigate(`/admin/policies/detail?id=${id}`);
        }}
      />
      <ToastContainer />
    </div>
  );
}
